import { Form, Radio } from 'antd';
import { FormattedMessage } from 'react-intl';

const PeriodRangeDropdown = () => {
    return (
        <>
            <Form.Item label="Period Range" name="periodRange">
                <Radio.Group defaultValue={"TODAY"} buttonStyle="solid">
                    <Radio.Button value="TODAY"><FormattedMessage id='TODAY' /></Radio.Button>
                    <Radio.Button value="YESTERDAY"><FormattedMessage id='YESTERDAY' /></Radio.Button>
                    <Radio.Button value="THIS-WEEK"><FormattedMessage id='THIS_WEEK' /></Radio.Button>
                    <Radio.Button value="LAST-WEEK"><FormattedMessage id='LAST_WEEK' /></Radio.Button>
                    <Radio.Button value="THIS-MONTH"><FormattedMessage id='THIS_MONTH' /></Radio.Button>
                    <Radio.Button value="LAST-MONTH"><FormattedMessage id='LAST_MONTH' /></Radio.Button>
                </Radio.Group>
            </Form.Item>

        </>
    )
}

export default PeriodRangeDropdown;